import * as React from "react"

// Components
import ProjectInfo from "../ProjectInfo"
import FullscreenImage from "../FullscreenImage"
import InsetImage from "../InsetImage"
import FourImageGrid from "../FourImageGrid"
import BreakBanner from "../BreakBanner"
import TestimonialBanner from "../TestimonialBanner"
import EmblaConstraintCarousel from "../Carousels/ConstCarousel/EmblaConstraintCarousel"
import BlockText from "../BlockText"
import PostVideo from "../PostVideo"

// Props
interface ModulesProps {
  module: any
  project?: any
}

const Modules: React.FunctionComponent<ModulesProps> = ({ project, module }) => {
  // console.log(module)
  switch (module._type) {
    case "projectHeroInfo":
      return <ProjectInfo module={module} project={project} />
    case "fullscreenImage":
      return <FullscreenImage module={module} />
    case "insetImage":
      return <InsetImage module={module} />
    case "imageGrid":
      return <FourImageGrid module={module} />
    case "projectBanner":
      return <BreakBanner module={module} />
    case "imageCarousel":
      return <EmblaConstraintCarousel slides={module.images} />
    case "testimonial":
      return <TestimonialBanner module={module} />
    case "blockText":
      return <BlockText module={module} />
    case "video":
      return <PostVideo module={module} />
    default:
      return <p>No content available</p>
  }
}

export default Modules
